/** @jsxImportSource @emotion/react */
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@emotion/react';
import makeErrorPageStyling from './makeErrorPageStyling';

const ErrorPage = ({ Icon, title, isRtl, children }) => {
  const theme = useTheme();
  const styling = makeErrorPageStyling({ theme, isRtl });
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      css={styling.gridContainer}
      data-testid="errorPageContainer"
    >
      <Grid item>
        <Icon css={styling.icon} />
      </Grid>
      <Grid item>
        <Typography variant="h5" css={styling.title}>
          {title}
        </Typography>
      </Grid>
      <Grid css={styling.message} item>
        {children}
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
